import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { TestPage } from '../test/test';
import { User } from '../../providers';

/**
 * Generated class for the StepsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-steps',
  templateUrl: 'steps.html',
})
export class StepsPage {

  private loginErrorString: string;

  slides = [
    {
      title: "Bienvenido a Oriéntate.gt",
      description: "Hemos diseñado una prueba de intereses para ayudarte a elegir qué carrera estudiar. Antes de iniciar la prueba porfavor lee detenidamente las siguientes instrucciones:",
      image: "assets/img/ica-slidebox-img-1.png",
    },
    {
      title: "1.",
      description: "<b>Al iniciar el test,</b> lee detenidamente cada pregunta antes de responder.",
      image: "assets/img/ica-slidebox-img-2.png",
    },
    {
      title: "2.",
      description: "Considera que no hay respuestas <b>buenas ni malas</b> y solo te llevará de 10 a 15 minutos contestar el cuestionario. Para que puedas obtener los mejores resultados, es necesario que lo contestes con honestidad y exactitud.",
      image: "assets/img/ica-slidebox-img-3.png",
    },
    {
      title: "3.",
      description: "Al finalizar la prueba puedes descargar tu hoja de orientación.",
      image: "assets/img/ica-slidebox-img-3.png",
    }
  ];

  constructor(public navCtrl: NavController, public navParams: NavParams, public user: User, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad StepsPage');
  }

  launch() {

    var url = "accounts/getAnsweredCount?access_token=".concat(this.navParams.get("token")).concat("&data=").concat("{\"id\":\""+this.navParams.get("user")+"\"}");

      this.user.getAnsweredCount(url, {}).subscribe((resp) => {
        console.log("Ok: status: "+resp);
        console.log("Ok: data: "+ JSON.stringify(resp)); // data received by server

        console.log(""+resp['data']);
        console.log(""+JSON.stringify(resp['data']));

        console.log(""+resp['data']['teststatus']);
        console.log(""+JSON.stringify(resp['data']['answered']));

        this.navCtrl.push(TestPage, 
        { 
            user: this.navParams.get("user"),
            answered: resp['data']['answered'],
            token: this.navParams.get("token")
        });
      }, (err) => {
        console.log("Ok: status: "+err);
        console.log("Ok: data: "+ JSON.stringify(err)); // data received by server
        //console.log("Ok: headers: "+resp.headers); 
        //this.showAlert("Ok: "+JSON.stringify(err), "Resp: "+err);
        //this.navCtrl.push(MainPage);
        // Unable to log in
        this.showAlert("Error",""+JSON.stringify(err));
        let toast = this.toastCtrl.create({
          message: this.loginErrorString,
          duration: 3000,
          position: 'top'
        });
        toast.present();
      });

    
    //this.router.navigate(['test'], this.navigationExtras);
  }

  showAlert(tit: string, msj: string) {
    const alert = this.alertCtrl.create({
      title: tit,
      subTitle: msj,
      buttons: ['Aceptar']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/steps/steps.ts